var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2154",
    "data-name": "Group 2154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87,
    height: 108.843,
    viewBox: "0 0 87 108.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5044",
    "data-name": "Path 5044",
    d: "M337.006,1583.952l-17.73,20.327-9.868-9.867a2.927,2.927,0,0,0-4.139,4.139l10.655,10.655c1.127,1.126,2.345,2.654,4.149,2.2,1.216-.305,1.946-1.382,2.73-2.266,2.257-2.548,17.322-19.859,18.617-21.344a2.93,2.93,0,0,0-.283-4.131h0a2.934,2.934,0,0,0-4.131.283m-15.111-33.945c6.483,8.83,20.7,15,35.922,15q.866,0,1.724-.023l0,0v21.6c0,19.473-10.05,37.867-26.887,49.21l-11.191,7.535-10.871-7.487c-16.495-11.361-26.34-29.614-26.34-48.836v-22.026c.572.014,1.147.023,1.724.023,15.223,0,29.439-6.169,35.922-15m-2.761-7.087c-2.788,7.982-15.952,16.234-33.157,16.234-1.5,0-2.979-.06-4.431-.169a2.9,2.9,0,0,0-2.21.771,2.928,2.928,0,0,0-.938,2.147v25.105c0,21.146,10.794,41.2,28.871,53.656l12.515,8.619a2.923,2.923,0,0,0,3.3.018l12.844-8.65c18.454-12.43,29.471-32.642,29.471-54.065V1561.9h0a2.929,2.929,0,0,0-.938-2.147,2.889,2.889,0,0,0-2.21-.771c-1.453.109-2.928.169-4.431.169-17.206,0-30.37-8.253-33.157-16.234a2.928,2.928,0,0,0-5.528,0",
    transform: "translate(-278.397 -1540.958)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.929,
    y1: 1.495,
    x2: -0.926,
    y2: 1.495,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59964a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc14b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2153",
    "data-name": "Group 2153",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 87,
    height: 108.843,
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestion);
export default __webpack_public_path__ + "static/media/gestion.83e3360c43c3905c59429398b260c021.svg";
export { ForwardRef as ReactComponent };